import React from "react"
import { Box } from "@mui/material"

const styles = {
	gap: "20px",
	rowGap: "15px",
	display: "flex",
	flexWrap: "wrap",

	"@media (max-width:600px)": {
		gap: "10px"
	}
}

export default function FieldContainer({ children }) {
	return <Box sx={styles}>{children}</Box>
}
